import { IntegrationsSubPanel } from '../..';
import CardDav from './CardDav';
import Zapier from './Zapier';

export const integrationsSubSectionPanels: Record<IntegrationsSubPanel, () => JSX.Element> = {
  'card-dav': CardDav,
  'zapier': Zapier,
};
